/*~~~~~~~~~ Tushar 2026-05-20 PMS(19528)*/
import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ExcelDateFormatterService {

  applyDateFormat(worksheet: XLSX.WorkSheet, json: any[]): XLSX.WorkSheet {
    if (json.length === 0) return worksheet;

    const ref = worksheet['!ref'];
    if (!ref) return worksheet;
    const range = XLSX.utils.decode_range(ref);
    const headers = Object.keys(json[0]);

    for (let col = range.s.c; col <= range.e.c; col++) {
      const colHeader = headers[col];
      if (isNullOrUndefined(colHeader) || colHeader === '') continue;
      if (this.isDateColumn(json, colHeader)) {
        for (let row = range.s.r + 1; row <= range.e.r; row++) {
          const cell = worksheet[XLSX.utils.encode_cell({ r: row, c: col })];
          if (cell && cell.v) {
            const m = moment(String(cell.v).trim(), 'DD-MM-YYYY', true);
            if (m.isValid()) {
              cell.t = 'n';
              cell.v = this.dateToExcelSerial(m);
              cell.z = 'dd/mm/yyyy';
            }
          }
        }
      }
    }
    return worksheet;
  }

  private isDateColumn(json: any[], colHeader: string): boolean {
    return json
      .map(row => row[colHeader])
      .filter(val => !isNullOrUndefined(val) && val !== '')
      .slice(0, 5)
      .every(val => moment(String(val).trim(), 'DD-MM-YYYY', true).isValid());
  }

  private dateToExcelSerial(m: moment.Moment): number {
  const excelEpoch = Date.UTC(1900, 0, 1);
  const dateUtc   = Date.UTC(m.year(), m.month(), m.date());
  const dayOffset = 2;
  return Math.round(
    (dateUtc - excelEpoch) / 86400000
  ) + dayOffset;
}

}
/*~~~~~~~~~ PMS(19528)*/